package com.siriusxm.cmc.utils

import kotlinx.serialization.json.*

public inline fun <reified I> Json.recode(el: JsonElement): JsonElement {
    val decoded: I = decodeFromJsonElement<I>(el)
    return encodeToJsonElement(decoded)
}

public inline fun <reified I, reified O> Json.recode(input: I): O {
    val inputEncoded = encodeToJsonElement(input)
    return decodeFromJsonElement(inputEncoded)
}

/**
 * Get the string value with the given key.
 */
public fun JsonObject.getString(key: String): String? {
    return get(key)?.jsonPrimitive?.contentOrNull
}

public fun JsonElement.getString(key: String): String? {
    return (this as? JsonObject)?.getString(key)
}

/**
 * Get the float value with the given key.
 */
public fun JsonObject.getFloat(key: String): Float? {
    return get(key)?.jsonPrimitive?.floatOrNull
}

public fun JsonElement.getFloat(key: String): Float? {
    return (this as? JsonObject)?.getFloat(key)
}


/**
 * Copy the given object, allowing for augmenting or replacing fields.
 */
public fun JsonObject.copy(block: JsonObjectBuilder.() -> Unit): JsonObject {
    return buildJsonObject {
        this@copy.forEach { (key, value) ->
            this.put(key, value)
        }
        block()
    }
}

/**
 * Copy and apply the update or create a new object
 */
public fun JsonObject?.copyOrBuild(block: JsonObjectBuilder.() -> Unit): JsonObject {
    return this?.copy(block) ?: buildJsonObject(block)
}